import { useState, useContext } from "react";
import { useUpgradeWsService } from "../service";
import { copyToClipBoard, downloadTextAsFile, aesDecrypt } from "lib/utils";
import Modal from "react-modal";
import { ConfirmModalStyles } from "lib/constants";
import { showToast } from "ui/components/common";
import { Button } from "antd";
import { SignalContext } from "context/SignalContext";
export default function TomlDownloader({
  deviceItem,
  orgId,
}: {
  deviceItem: any;
  orgId: string;
}) {
  const { sessionId } = useContext(SignalContext);
  const { sendTomlRequest } = useUpgradeWsService();
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const [enabled, setEnabled] = useState(true);
  const [type, setType] = useState("p2p");
  const [passwordText, setPasswordText] = useState("");
  const [newPasswordText, setNewPasswordText] = useState("");
  const [webPasswordText, setWebPasswordText] = useState("");

  return (
    <>
      <Modal
        isOpen={modalShow}
        style={ConfirmModalStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-xl font-bold">
          About to send remote ssh request to this nvr
        </h1>
        <div className="text-base mt-4">
          <div style={{ margin: "10px 0px" }}>
            {"Device Id: " + deviceItem.deviceId}
          </div>
          <input
            type="radio"
            id="enable"
            name="enableOptions"
            checked={enabled}
            onChange={() => {
              setEnabled(true);
            }}
          />
          <label className="ml-1">enable</label>
          <input
            className="ml-1"
            type="radio"
            id="disable"
            name="enableOptions"
            checked={!enabled}
            onChange={() => {
              setEnabled(false);
            }}
          />
          <label className="ml-1">disable</label>
        </div>
        <div className="text-base mt-4">
          <input
            type="radio"
            id="p2p"
            name="typeOptions"
            checked={type === "p2p"}
            onChange={() => {
              setType("p2p");
            }}
          />
          <label className="ml-1">p2p</label>
          <input
            className="ml-1"
            type="radio"
            id="renmote"
            name="typeOptions"
            checked={type === "remote"}
            onChange={() => {
              setType("remote");
            }}
          />
          <label className="ml-1">remote</label>
          <input
            className="ml-1"
            type="radio"
            id="all"
            name="typeOptions"
            checked={type === "all"}
            onChange={() => {
              setType("all");
            }}
          />
          <label className="ml-1">all</label>
          {passwordText && (
            <>
              <div
                style={{ marginTop: "20px" }}
              >{`password:${passwordText}`}</div>
              <a
                onClick={() => {
                  copyToClipBoard(passwordText);
                }}
                className="text-blue-600 hover:text-blue-500 underline"
                style={{ cursor: "pointer" }}
              >
                Click to Copy Password
              </a>
            </>
          )}
          {newPasswordText && (
            <>
              <div
                style={{ marginTop: "20px" }}
              >{`new password:${newPasswordText}`}</div>
              <a
                onClick={() => {
                  copyToClipBoard(newPasswordText);
                }}
                className="text-blue-600 hover:text-blue-500 underline"
                style={{ cursor: "pointer" }}
              >
                Click to Copy New Password
              </a>
            </>
          )}
          {webPasswordText && (
            <>
              <div
                style={{ marginTop: "20px" }}
              >{`web password:${webPasswordText}`}</div>
              <a
                onClick={() => {
                  copyToClipBoard(webPasswordText);
                }}
                className="text-blue-600 hover:text-blue-500 underline"
                style={{ cursor: "pointer" }}
              >
                Click to Copy Password
              </a>
            </>
          )}
        </div>
        <div className="float-right mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setLoading(false);
              setModalShow(false);
            }}
          >
            Cancel
          </button>
          {loading ? (
            <div
              className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            ></div>
          ) : (
            <button
              className="ml-4 rounded-2xl px-6 py-4 bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
              onClick={() => {
                setLoading(true);
                sendTomlRequest(enabled, deviceItem.deviceId, type)
                  .then(async (data: any) => {
                    setLoading(false);
                    const result = data.deviceRemoteSshReply;
                    if (result) {
                      showToast(0, "Success");
                    } else {
                      showToast(1, "Failed Msg:" + data.message);
                    }
                    if (!enabled) {
                      return;
                    }
                    downloadTextAsFile(
                      result.config,
                      deviceItem.deviceId + ".toml",
                    );
                    setPasswordText(result.nvrPasswd);
                    setNewPasswordText(result.nvrPasswdNew);
                    if (result.nvrWebPassword) {
                      const pwd = aesDecrypt(
                        result.nvrWebPassword,
                        sessionId.slice(0, 32),
                      );
                      setWebPasswordText(pwd);
                    }
                  })
                  .catch((e) => {
                    showToast(1, e.toString());
                    console.error(e);
                    setLoading(false);
                  });
              }}
            >
              Send
            </button>
          )}
        </div>
      </Modal>
      {deviceItem.status !== "offline" && (
        <Button onClick={() => setModalShow(true)} type="link">
          Remote SSH
        </Button>
      )}
    </>
  );
}
